import { render, staticRenderFns } from "./FbGroup.vue?vue&type=template&id=21b9d8fc"
import script from "./FbGroup.vue?vue&type=script&lang=js"
export * from "./FbGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports